import _ from 'lodash'
import moment from 'moment'
import { Log, LogRaw, Category } from '../types'

export const timeLabel = (timestamp: number) => {
  const m = moment(timestamp)

  return m.format(`YYYY/MM/DD HH:mm:ss (${m.fromNow()})`)
}

export const toLog = (old: LogRaw, id = '-'): Log => {
  return {
    id,
    timestamp: old.timestamp,
    timeLabel: timeLabel(old.timestamp),
    fields: old.fields,
  }
}

export function makeCSV(logs: Log[]): string {
  const log = logs.shift()

  if (!log) {
    return 'noLog'
  }
  const head = ['timestamp', 'timestampStr', 'id', ...Object.keys(log.fields)]

  const toLine = (log: Log) => {
    return [
      log.timestamp,
      moment(log.timestamp).format('YYYY-MM-DD HH:mm:ss'),
      log.id,
      ..._.values(log.fields),
    ].map(String)
  }
  const cells = [head, ...logs.map(toLine)]

  return cells.map((vs) => vs.join(',')).join('\n')
}

export function download(text: string, name: string) {
  const href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(text)
  const a = document.createElement('a')

  a.setAttribute('href', href)
  a.setAttribute('download', name + '.csv')
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  document.body && document.body.appendChild(a)
  a.click()
  a.remove()
}

const genPasswordUnit = () => Math.random().toString(36).slice(-8)

export const genPassword = () =>
  genPasswordUnit() + genPasswordUnit() + genPasswordUnit()

export const categories: { [Id in Category]: string } = {
  zyuutenmieruka: 'ジュウテン',
  roadcell: 'ロードセル',
  zentyou: 'ゼンチョウ',
  roadcell_zentyou: 'ロードセル・ゼンチョウ',
  yuatsu: '液圧センサシステム',
}

const tokenTable =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

export const genToken = (n = 32) =>
  Array.from(Array(n))
    .map(() => tokenTable[Math.floor(Math.random() * tokenTable.length)])
    .join('')

export const unix = () => Math.floor(+new Date() / 1000)

export function toYmdStr(d: Date, sp = '-'): string {
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')

  return `${yyyy}${sp}${mm}${sp}${dd}`
}

export function toYmdHmsStr(d: Date): string {
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  const ss = String(d.getSeconds()).padStart(2, '0')

  return `${toYmdStr(d, '/')} ${hh}:${mm}:${ss}`
}

export const substruct = <T>(a: T[], b: T[]) => a.filter((x) => !b.includes(x))
